import { FC, memo, useContext } from 'react';

import { Button } from '@smartshell/ui-kit';
import dayjs from 'dayjs';

import { AuthContext } from 'auth';
import { FeaturesContext } from 'features';
import { LocalizationContext } from 'localization';

import s from './Subscription.module.scss';

export const Subscription: FC = memo(() => {
  const { t } = useContext(LocalizationContext);

  const {
    data: { me },
  } = useContext(AuthContext);
  const { expiresAt } = useContext(FeaturesContext);

  return (
    <div className={s.container}>
      <div className={s.info}>
        {t(
          me?.is_owner
            ? 'subscription.expires.subscription.owner'
            : 'subscription.expires.subscription',
          expiresAt ? dayjs(expiresAt).format('D MMMM') : ''
        )}
      </div>
      {me?.is_owner && (
        <Button
          color="orange"
          size="s"
          variant="secondary"
          className={s.renew}
          onClick={() => open('https://lk.smartshell.gg')}
        >
          {t('subscription.renew')}
        </Button>
      )}
    </div>
  );
});
